import { useEffect, useState, useCallback } from "react";
import { getCashLocations } from "../api";
import moment from "moment";

export const useCashLocations = (
  initial = { pageNo: 0, pageSize: 10 },
  options = { enabled: false } ,
  businessAreasAccess =[],
  paymentType
) => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNo, setPageNo] = useState(initial.pageNo);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(initial.pageSize);
  
  // Initialize filters, potentially from arguments if needed in the future
  const [filters, setFilters] = useState({ businessAreas: []});

  const fetchData = useCallback(async (p = pageNo, ps = pageSize, fl = filters) => {
    if (!options.enabled && !fl) return; 

    setLoading(true);
    try {
      const { rows, total, totalPages } = await getCashLocations({
        pageNo: p,
        businessAreasAccess,
        paymentType,
        pageSize: ps,
        ...fl,
      });
      setRows(rows);
      setTotal(total);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Failed to fetch locations", error);
    } finally {
      setLoading(false);
    }
  }, [pageNo, pageSize, filters, options.enabled]); 
  // Note: We include state deps here so the function has access to latest values if called without args

  // 3. The Effect now depends on the 'enabled' flag
  useEffect(() => {
    if (options.enabled) {
      fetchData();
    }
  }, [options.enabled]); // Only re-run if the enabled status changes

  const nextButtonHandler = (newPageNo, newPageSize) => {
    setPageNo(newPageNo);
    setPageSize(newPageSize);
    // Explicitly pass args to avoid async state issues
    fetchData(newPageNo, newPageSize, filters);
  };

  const applyFilter = (currentFilter) => {
    setPageNo(0);
    setFilters(currentFilter);
    // Explicitly pass args to avoid async state issues
    fetchData(0, pageSize, { ...currentFilter, startDate: currentFilter.startDate? moment(currentFilter?.startDate)?.startOf('day'): '', endDate: currentFilter.endDate? moment(currentFilter?.endDate)?.endOf('day') : '' });
  };

  return {
    rows,
    total,
    totalPages,
    loading,
    pageNo,
    pageSize,
    nextButtonHandler,
    fetchData,
    applyFilter,
    filters,
  };
};